import { Navigate } from "react-router-dom";
import { isEventPartnerAuthenticated } from "@/services/eventPartnerService";

interface EventPartnerProtectedRouteProps {
  children: React.ReactNode;
}

export const EventPartnerProtectedRoute = ({ children }: EventPartnerProtectedRouteProps) => {
  if (!isEventPartnerAuthenticated()) {
    return <Navigate to="/Event-Partner-Login" replace />;
  }

  return <>{children}</>;
};
